import { formatMoney } from './chunk-W5SU5LQ2.mjs';
import { selectCurrentTimeZone, dateTimeMsToTodayDateCore, getHourMsCore } from './chunk-RO5AAHK3.mjs';
import { menuSpecialCardFactory } from './chunk-XGMI2YD6.mjs';
import { i18n_config_default } from './chunk-5FPUWZMY.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import isEqual from 'lodash/isEqual';
import orderBy from 'lodash/orderBy';
import uniqWith from 'lodash/uniqWith';
import { DateTime } from 'luxon';

var getNullOrValue = (input) => {
  const uniqueArray = uniqWith(input, isEqual);
  return input.length === 1 ? input[0] : uniqueArray.length === 1 ? input[0] : null;
};
var DAYS_IN_ORDER = [
  "monday" /* MONDAY */,
  "tuesday" /* TUESDAY */,
  "wednesday" /* WEDNESDAY */,
  "thursday" /* THURSDAY */,
  "friday" /* FRIDAY */,
  "saturday" /* SATURDAY */,
  "sunday" /* SUNDAY */
];
var menuSpecialsTableFactoryCore = (specials, menuTypes, state) => {
  return Object.values(specials).map((special) => {
    const specialCoreCard = menuSpecialCardFactory({
      [special.specialId]: special
    })[0];
    const children = [];
    const timeZone = selectCurrentTimeZone(state);
    const getStringTimes = (times) => {
      let stringTimes = "";
      if (times.length === 0)
        return stringTimes;
      orderBy(times, "startTime").forEach((time, index) => {
        stringTimes = `${stringTimes}${index ? ", " : ""}${DateTime.fromISO(
          dateTimeMsToTodayDateCore(
            getHourMsCore(time.startTime, timeZone),
            false,
            state
          )
        ).toUTC().toFormat("hh:mm a")} - ${DateTime.fromISO(
          dateTimeMsToTodayDateCore(
            getHourMsCore(time.endTime, timeZone),
            false,
            state
          )
        ).toUTC().toFormat("hh:mm a")}`;
      });
      return stringTimes;
    };
    Object.values(special.menuTypeVersions).forEach((menuTypeVersion) => {
      var _a, _b;
      let availability = "";
      DAYS_IN_ORDER.forEach((day, index) => {
        const isLastDay = index === DAYS_IN_ORDER.length - 1;
        const times = menuTypeVersion.availableTimes[day];
        const nextTimes = isLastDay ? [] : menuTypeVersion.availableTimes[DAYS_IN_ORDER[index + 1]];
        if (times.length === 0)
          return;
        const stringTimes = getStringTimes(times);
        const nextStringTimes = getStringTimes(nextTimes);
        const timesAreEqual = stringTimes === nextStringTimes;
        availability = `${availability}${availability ? ", " : ""}${i18n_config_default.t(`settingsModule.printerRulesSettings.abbreviatedDays.${day}`)}`;
        if (isLastDay || !timesAreEqual) {
          availability = `${availability} (${stringTimes})`;
        }
      });
      children.push({
        id: menuTypeVersion.menuTypeId,
        title: (_a = menuTypes[menuTypeVersion.menuTypeId]) == null ? void 0 : _a.name,
        isHidden: !((_b = menuTypes[menuTypeVersion.menuTypeId]) == null ? void 0 : _b.active),
        status: menuTypeVersion.active,
        applyTo: menuTypeVersion.specialApplyTo === "bogo" /* BOGO */ ? i18n_config_default.t("menuScreen.specialsMain.table.bogo", {
          buy: menuTypeVersion.buyQuantity,
          get: menuTypeVersion.getQuantity
        }) : i18n_config_default.t(
          `menuScreen.specialDetails.scheme.applyTo.options.${menuTypeVersion.specialApplyTo}`
        ),
        availability: availability || void 0,
        discountType: `${i18n_config_default.t(`menuScreen.discountDetails.discountScheme.inputs.discountType.options.${menuTypeVersion.discountType}`)} (${menuTypeVersion.discountType === "percent" /* PERCENT */ ? `${menuTypeVersion.discountAmount}%` : formatMoney(null, menuTypeVersion.discountAmount)})`,
        itemsAndCombos: [
          menuTypeVersion.buyItemIds.length,
          menuTypeVersion.buyComboIds.length
        ],
        locationsCount: 0,
        locationIds: [],
        applyToEnumValue: menuTypeVersion.specialApplyTo
      });
    });
    return __spreadProps(__spreadValues({}, specialCoreCard), {
      isHidden: getNullOrValue(children.map((child) => child.isHidden)) || false,
      status: true,
      children,
      itemsAndCombos: getNullOrValue(
        children.map((child) => child.itemsAndCombos)
      ),
      availability: getNullOrValue(children.map((child) => child.availability)),
      applyTo: getNullOrValue(children.map((child) => child.applyTo)),
      discountType: getNullOrValue(children.map((child) => child.discountType)),
      applyToEnumValue: getNullOrValue(
        children.map((child) => child.applyToEnumValue)
      )
    });
  });
};

export { menuSpecialsTableFactoryCore };
